export default __webpack_public_path__ + "static/media/upgrade.cb2e65d6.svg";